// removed by extract-text-webpack-plugin
module.exports = {"Navbar":"Navbar__Navbar__2CPxl","Navbar__Content":"Navbar__Navbar__Content__W4jHw","DesktopOnly":"Navbar__DesktopOnly__1CeuD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/Navbar/Navbar.css
// module id = 131
// module chunks = 0